import { render, staticRenderFns } from "./approveallorganizations.vue?vue&type=template&id=2721fde3&scoped=true"
import script from "./approveallorganizations.vue?vue&type=script&lang=js"
export * from "./approveallorganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721fde3",
  null
  
)

export default component.exports